module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/thumbs_up-45b44cee743e52956cfd68ac01e35596.svg";